import { Select } from "antd";
import { useGetCompaniesQueryV2 } from "@xemplo/directory-services-query";
import { CompanyApiModel } from "@xemplo/types";

type DirectoryServiceCompanyLookupProps = {
  /** Injected by antd `getFieldDecorator` — the selected DS company id. */
  value?: number;
  /** Injected by antd `getFieldDecorator` — fires on selection change. */
  onChange?: (value: number) => void;
  directoryServiceProviderId: number | null | undefined;
};

/** Single-select of an existing Directory Service company (V2, unfiltered list). */
export const DirectoryServiceCompanyLookup = ({
  value,
  onChange,
  directoryServiceProviderId,
}: DirectoryServiceCompanyLookupProps) => {
  const { data, isLoading } = useGetCompaniesQueryV2({
    params: {
      serviceProviderId: directoryServiceProviderId ?? undefined,
    },
  });

  return (
    <Select
      placeholder="Select"
      optionFilterProp="children"
      onChange={onChange}
      loading={isLoading}
      showSearch
      value={value}
    >
      {data?.map((company: CompanyApiModel) => (
        <Select.Option key={company.id} value={company.id}>
          {company.name} - {company.id}
        </Select.Option>
      ))}
    </Select>
  );
};
